import { Grid, Typography } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import classnames from 'classnames';
import React, { Component } from 'react';
import { Link } from 'react-router-dom';

const styles = theme => ({
  paperPadding: theme.mixins.gutters({
    paddingTop: 16,
    paddingBottom: 16,
  }),
  spacer: {
    marginTop: '15px',
    marginBottom: '15px'
  },

  bold: {
    fontWeight: '700',
  },
  subIndentation1: {
    marginLeft: '-20px',
    listStyleType: 'lower-alpha',
  },
  textSpacer: {
    '& p': {
      marginTop: '8px',
      marginBottom: '8px',
    }
  }

});


export const CCAgreementText = withStyles(styles)(function ({ classes }) {
  return (
    <>
      <div className={classes.textSpacer}>
        <Typography variant="h6" color="secondary" className={classes.bold}>
          AUTHORITIES GRANTED TO EASTWEST AND WAIVER OF CONFIDENTIALITY <br/>AGREEMENT (CREDIT CARD APPLICATION FORM) 
        </Typography>
        <Typography variant="body1" gutterBottom>
          I/We hereby certify that all information and documents given in this application are complete, true and correct and that my/our signatures herein are genuine.
        </Typography>

        <Typography variant="body1" className={classes.bold} gutterBottom>
          Disclosure and Sharing of Information
        </Typography>
        <ol className={classes.subIndentation1}>
          <li>
            <Typography variant="body1" className={classes.bold}>Processing of application </Typography>
            <Typography variant="body1" gutterBottom>
              I/We hereby consent and authorize EastWest, any of its offices, Stores, subsidiaries, affiliates, agents, representatives and third parties, to conduct random verification with the BIR, any other appropriate government agency or third party, including banks and financial institutions, to establish the authenticity of the information I/we declared and the documents I/we submitted in relation to my/our application as it may be necessary for the processing and evaluation of my/our application. I/We hereby waive any rights on the confidentiality of my/our income information as required by BSP Circular 622, as amended by BSP Circular 855. I/We further consent and authorize the disclosure of personal and sensitive personal information by the Bank, provided that such disclosure is in accordance with the provisions of Republic Act No. 10173 or the Data Privacy Act of 2012, its Implementing Rules and Regulations, and other rules and regulations relating to data privacy, including the Bank’s data privacy policy published in its website. </Typography>
          </li>
          <li>
            <Typography variant="body1" className={classes.bold}>Account Maintenance and Servicing </Typography>
            <Typography variant="body1" gutterBottom>
              I/We hereby authorize the transfer, disclosure and communication of EastWest of any information relating to my/I/We hereby authorize the transfer, disclosure and communication of EastWest of any information, including personal and sensitive personal information, relating to my/our account/s with EastWest together with all of the documents submitted for this application to any of its offices, Stores, subsidiaries, affiliates, agents, representatives and third parties for application processing, data processing/storage, customer satisfaction surveys, and for any other purpose as EastWest may deem appropriate, and/or as described in the Bank's data privacy policy, and as may be required by law or regulation. I/We hereby also authorize the regular submission and disclosure to any and all credit information service providers listed in the Bank's data privacy policy published in its website, of any information, whether positive or negative, relating to my/our basic credit data (as defined under Republic Act No. 9510) with EastWest, as well as any update or correction thereof. The foregoing constitutes my/our written consent for any such submission and disclosure of information relating to my/our account/s for the purpose indicated above and under applicable laws, rules and regulations. 
              <br /> <br />
              I/We agree to hold EastWest free and harmless from any liability that may arise from any transfer, disclosure or storage of information relating to my/our account/s.
            </Typography>
          </li>
          <li>
            <Typography variant="body1" className={classes.bold}>Marketing and Sales Offers </Typography>
            <Typography variant="body1" gutterBottom>
              I/We hereby authorize the transfer, disclosure and communication of EastWest of any information including personal and sensitive personal information relating to my/our account/s with EastWest together with all of the documents submitted for this application to any of its offices, Stores, subsidiaries, affiliates, agents, representatives of EastWest and third parties for product and service offers to be made to me/us through mail/e-mail/fax/SMS or telephone or through other forms of media, including social media, and for any other purpose as EastWest may deem appropriate, and/or as described in the Bank’s data privacy policy published in its website, unless I/we expressly notify EastWest otherwise through the following contact information: 
            </Typography>
            <Typography variant="body1" gutterBottom>
              <table border='1' class='jsontable'>
                <tr>
                  <td><strong>Chatbot (via web browser):</strong></td>
                  <td><a href="m.me/EWBESTA" target="_blank" rel="noopener noreferrer" className="content-link">m.me/EWBESTA</a></td>
                </tr>
                <tr>
                  <td><strong>Customer Service Hotline</strong></td>
                  <td><a href="tel:+0288881700" className="content-link">(+632) 8888-1700</a></td>
                </tr>
                <tr>
                  <td><strong>Email</strong></td>
                  <td><a href="mailto:cards@eastwestbanker.com" className="content-link">cards@eastwestbanker.com</a></td>
                </tr>
              </table>
            </Typography>
            <Typography variant="body1" gutterBottom>
             I/We understand that this application is subject to EastWest's credit policies and procedures. I/We understand and agree that should my/our credit card application be approved, my/our Card/s may be delivered activated subject to EastWest's activation policy and guidelines. Once activated, I/we also authorize EastWest to deliver my/our replacement and/or renewal Card/s activated. In case of disapproval of my/our application, I/we understand that EastWest is under no obligation to disclose the reason/s for such disapproval unless required by law or regulation. The accomplished application form and requirements I/we submitted become the property of EastWest, and the Bank is under no obligation to return the said documents to me/us regardless of the outcome of the application. 
            </Typography>
            <Typography variant="body1" gutterBottom>
             In case of approved credit card application or if I/we are deemed qualified by EastWest for credit card issuance, I/we understand and agree that my/our Card/s may be delivered activated subject to EastWest’s activation policy and guidelines. 
            </Typography>
            <Typography variant="body1" gutterBottom>
              By signing below, I/we also acknowledge that I/we have fully read and understood the Terms and Conditions Governing the Issuance and Use of EastWest Credit Cards as found in the Bank's website and the Bank's <a href="https://www.ewbanker.com/info/ew_privacy.asp" rel="noopener noreferrer" target="_blank" >data privacy policy published in its website.</a> I/We agree to abide by and be bound by the said Terms and Conditions and data privacy policy, as well as all laws, rules, regulations and official issuances applicable to EastWest which may hereinafter be issued, including other terms and conditions governing the use of other facilities, benefits, products or services which shall be made available to me/us. I/We also agree that EastWest may amend from time to time its Terms and Conditions, which include the fees and charges for its products and/or services, and its data privacy policy, and I/we agree to be notified of such changes through notice sent to me/us through any of the following means, at the option of EastWest unless I/we request otherwise: (i) mailed and/or e-mailed notices (sent to my/our mailing or e-mail addresses indicated in EastWest's records), (ii) notices posted at EastWest's Stores or (iii) notices in its website, and I/we agree to be bound by such changes unless I/we expressly notify EastWest otherwise through the contact information indicated above. 
            </Typography>
          </li>
          <li>
            <Typography variant="body1" className={classes.bold}>Card Delivery </Typography>
            <Typography variant="body1" gutterBottom>I/We authorize EastWest or its official courier to deliver the Card/s to me/us, to any member of my/our household, to any of my/our officemate/co-employee or to any other person that I/we may authorize through an authorization letter, subject to the existing delivery policy of EastWest. I/We agree to hold EastWest free and harmless from any claim, loss or liability, whatsoever arising from the delivery of the Card/s to my/our authorized representative. </Typography>
          </li>
        </ol>
      </div>
    </>
  )
});

export default withStyles(styles)(class extends Component {
  constructor(props) {
    super(props);
    this.state = {
      expanded: null,
    };
    this.handleChange = panel => (event, expanded) => {
      this.setState({
        expanded: expanded ? panel : false,
      });
    };
  }
  render() {
    const { classes } = this.props;


    return (
      <>
        {/* <div id="pageBanner">
          <RenderPageBanner banner="/images/eastwestbank-supportsecurity-faqs-banner.jpg" bgColor="#fff">
            <RenderSupportHeader section="Weekend Banking" page="Frequently Asked Questions" />
          </RenderPageBanner>
        </div>
        <section className="greyBG">
          <Grid container className="gridContainer">
            <Grid item xs={12} md={8}>
              <TermsOfUseText />
            </Grid>
            <Hidden smDown>
              <Grid item md={4} className={classnames(classes.spacer, classes.paperPadding)}>
                <Paper style={{ padding: '15px', marginBottom: '1rem' }} className={classes.linkHover}>
                  <Link to="/" style={{ textDecoration: 'none' }}><SectionTitle header={<Fragment ><ChevronLeft style={{ verticalAlign: 'middle', fontSize: '30px' }} />Back to Home</Fragment>} fontColor="primary" /> </Link>

                </Paper>
              </Grid>
            </Hidden>
          </Grid>

        </section> */}
        <Grid container className={classnames(classes.spacer, classes.paperPadding)}>
          {/* <Grid item xs={12} md={8}> */}
          <CCAgreementText />
        </Grid>
      </>
    );
  }
});